import { useState } from 'react'
import { Navigate } from 'react-router-dom'
import { useTabletContext } from './TabletLayout'

type Choice = { label: string; value: string }

const QUESTIONS: readonly { title: string; detail: string; choices: readonly Choice[] }[] = [
  {
    title: '¿Cuánto dormiste anoche?',
    detail: 'Elegí la opción que más se acerque.',
    choices: [
      { label: '< 6 h', value: 'lt6' },
      { label: '~ 8 h', value: 'about8' },
      { label: '> 9 h', value: 'gt9' },
    ],
  },
  {
    title: '¿Tomaste cafeína en las últimas 2 horas?',
    detail: 'Café, mate, té o energizante.',
    choices: [
      { label: 'Sí', value: 'yes' },
      { label: 'No', value: 'no' },
    ],
  },
  {
    title: '¿Cuándo fue tu último entrenamiento físico?',
    detail: 'Elegí la referencia más cercana.',
    choices: [
      { label: 'Hoy', value: 'today' },
      { label: 'Ayer', value: 'yesterday' },
      { label: 'Hace más tiempo', value: 'earlier' },
    ],
  },
]

/**
 * Chequeo previo local de la tablet. No se envía ni se asocia a la sesión:
 * sirve únicamente como preparación breve antes de ir al visor.
 */
export function TabletCheckIn() {
  const { phase, onCheckInDone, endSession } = useTabletContext()
  const [step, setStep] = useState(0)
  const [answers, setAnswers] = useState<string[]>([])

  if (phase !== 'checkin') return <Navigate to="/tablet" replace />

  const question = QUESTIONS[step]!
  const last = step === QUESTIONS.length - 1
  const choose = (value: string) => {
    setAnswers((current) => {
      const next = [...current]
      next[step] = value
      return next
    })
  }
  const selected = answers[step] ?? ''

  return (
    <div className="panel max-w-xl p-2xl">
      <p className="m-0 text-xs uppercase tracking-wide text-text-muted">
        Chequeo previo · {step + 1} de {QUESTIONS.length}
      </p>
      <h1 className="mt-xs text-2xl">{question.title}</h1>
      <p className="mt-sm text-base text-text-secondary">{question.detail}</p>

      <div className="mt-xl grid gap-md sm:grid-cols-3">
        {question.choices.map((choice) => (
          <button
            key={choice.value}
            type="button"
            onClick={() => choose(choice.value)}
            className={`rounded-xl border px-lg py-xl text-lg font-semibold transition-colors ${
              selected === choice.value
                ? 'border-[var(--club-primary)] bg-[var(--club-primary)] text-primary-fg'
                : 'border-outline bg-surface-highlight text-text-primary hover:border-[var(--club-primary)]'
            }`}
          >
            {choice.label}
          </button>
        ))}
      </div>

      <div className="mt-xl flex gap-md">
        <button
          type="button"
          className="btn flex-1 py-lg text-lg"
          disabled={step === 0}
          onClick={() => setStep((current) => Math.max(0, current - 1))}
        >
          Atrás
        </button>
        <button
          type="button"
          className="btn-primary flex-1 py-lg text-lg disabled:opacity-50"
          disabled={!selected}
          onClick={() => {
            if (last) onCheckInDone()
            else setStep((current) => current + 1)
          }}
        >
          {last ? 'Listo' : 'Continuar'}
        </button>
      </div>
      <button type="button" className="btn-ghost mt-md w-full py-md" onClick={endSession}>Salir</button>
    </div>
  )
}
